module.exports = __webpack_public_path__ + "static/nxrt-esports-6-0147b10f7f272cb7dc0595f6b70527f7.png";